export const evidence_explanation = `
    Before the song can be shown on the app, evidence of ownership is required in the form of a screenshot.
    This can be:
    * Email of upload to distributor
    * Spotify for artist page
    * Email from Spotify for artist
    * Another suitable image
`;

export const ACCEPTED_EVIDENCE = "Evidence accepted";
export const REJECT_EVIDENCE = "Song reject please reupload song";
export const EVIDENCE_UPLOADED = "Re-upload evidence if neccessary";
export const WAITING_FOR_EVIDENCE = "Waiting for Copyright Evidence Upload";

export const GENRES = ["rock", "pop", "metal", "hip hop", "jazz", "electronic"]